export default {
  toasts: {
    verification_pending: 'Vahvistuksesi on yhä kesken',
  },
};
